<template>
  <v-card class="pa-4">
    <v-form ref="form" v-model="valid">
      <v-card class="pa-4 mb-4" outlined>
        <h3 class="mb-4">Informations du sondage</h3>
        <v-text-field
          v-model="formData.title"
          label="Titre"
          :rules="[(v) => !!v || 'Le titre est requis']"
          required
        ></v-text-field>
        <v-text-field
          v-model="formData.titleEn"
          label="Titre en anglais"
          :rules="[(v) => !!v || 'Le titre en anglais est requis']"
          required
        ></v-text-field>
      </v-card>

      <v-card class="mt-4 pa-4" outlined>
        <h3 class="mb-4">Questions</h3>
        <v-btn color="primary" @click="addQuestion" class="mb-4">
          Ajouter une question
        </v-btn>

        <v-expansion-panels v-model="openPanelIndex" multiple>
          <v-expansion-panel v-for="(question, qIndex) in formData.investigationQstRespList" :key="qIndex">
            <v-expansion-panel-header>
              {{ question.question || "Nouvelle question" }}
              <template v-slot:actions>
                <v-btn icon small color="error" @click.stop="removeQuestion(qIndex, question)">
                  <v-icon small>mdi-delete</v-icon>
                </v-btn>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-text-field v-model="question.question" label="Question"
                :rules="[(v) => !!v || 'La question est requise']" required>
              </v-text-field>
              <v-text-field v-model="question.questionEn" label="Question en anglais"
                :rules="[(v) => !!v || 'La question en anglais est requise']" required>
              </v-text-field>
              <v-divider class="my-4"></v-divider>

              <h4 class="mb-2">Réponses</h4>
              <v-btn text color="primary" @click="addResponse(qIndex)" class="mb-2">
                Ajouter une réponse
              </v-btn>

              <v-card v-for="(response, rIndex) in question.investigationRespRespList" :key="rIndex" outlined
                class="mb-2 pa-2">
                <div class="d-flex align-center">
                  <v-text-field v-model="response.response" label="Réponse"
                    :rules="[(v) => !!v || 'La réponse est requise']" required class="mr-2" hide-details></v-text-field>
                  <v-text-field v-model="response.responseEn" label="Réponse en anglais"
                    :rules="[(v) => !!v || 'La réponse en anglais est requise']" required class="mr-2" hide-details></v-text-field>

                  <v-btn icon small color="error" @click="removeResponse(qIndex, rIndex, response.id)">
                    <v-icon small>mdi-delete</v-icon>
                  </v-btn>
                </div>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card>

      <v-btn color="primary" class="mt-4" @click="save" :disabled="!valid">
        Enregistrer
      </v-btn>
    </v-form>
  </v-card>
</template>
<script>
import axios from "axios";
import constants from "@/utils/constants";

export default {
  name: "InvestigationForm",
  props: {
    investigation: {
      type: Object,
    },
  },
  data() {
    return {
      valid: false,
      formData: {
        title: "",
        titleEn: "",
        investigationQstRespList: [],
      },
      openPanelIndex: null,
    };
  },
  watch: {
    investigation: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.formData = JSON.parse(JSON.stringify(newVal));
        } else {
          this.formData = {
            title: "",
            titleEn: "",
            investigationQstRespList: [],
          };
        }
      },
    },
  },
  methods: {
    test() {
      console.log(this.investigation);
    },
    addQuestion() {
      this.formData.investigationQstRespList.push({
        question: "",
        investigationRespRespList: [],
      });
      this.openPanelIndex = [this.formData.investigationQstRespList.length - 1];
    },
    async removeQuestion(index, question) {
      console.log(JSON.stringify(question));
      await axios.delete(
        `${constants.QORANI}investigationQst/delete/${question.id}`
      );
      this.formData.investigationQstRespList.splice(index, 1);
      if (this.openPanelIndex === index) {
        this.openPanelIndex = null;
      }
    },
    addResponse(questionIndex) {
      const question = this.formData.investigationQstRespList[questionIndex];
      question.investigationRespRespList.push({
        response: "",
        numberVote: 0,
      });
    },
    removeResponse(questionIndex, responseIndex, responseID) {
      axios.delete(`${constants.QORANI}investigationResp/delete/${responseID}`);
      const question = this.formData.investigationQstRespList[questionIndex];
      question.investigationRespRespList.splice(responseIndex, 1);
    },
    async save() {
      if (this.$refs.form.validate()) {
        try {
          if (this.formData.id) {
            // Mise à jour de l'enquête (titre)
            try {
              await axios.post(
                `${constants.QORANI}investigation/edit/${this.formData.id}`,
                {
                  title: this.formData.title,
                  titleEn: this.formData.titleEn,
                }
              );
            } catch (error) {
              console.error("Erreur lors de la mise à jour du titre de l'investigation:", error);
            }

            // Mise à jour des questions et réponses existantes
            for (const question of this.formData.investigationQstRespList) {
              if (question.id) {
                console.log(JSON.stringify(question));

                // Mise à jour de la question existante
                await axios.post(
                  `${constants.QORANI}investigationQst/edit/${question.id}`,
                  {
                    investigationId: question.investigationId,
                    question: question.question,
                    questionEn: question.questionEn,
                  }
                );
              } else {
                // Ajout d'une nouvelle question
                const questionResponse = await axios.post(
                  `${constants.QORANI}investigationQst/add`,
                  {
                    investigationId: this.formData.id,
                    question: question.question,
                    questionEn: question.questionEn,
                  }
                );
                question.id = questionResponse.data.id;
              }

              // Mise à jour des réponses
              for (const response of question.investigationRespRespList) {
                if (response.id) {
                  console.log(JSON.stringify(response));

                  // Mise à jour de la réponse existante
                  await axios.post(
                    `${constants.QORANI}investigationResp/edit/${response.id}`,
                    {
                      response: response.response,
                      responseEn: response.responseEn,
                      investigationQstId: response.investigationQtdId,
                    }
                  );
                } else {
                  // Ajout d'une nouvelle réponse
                  const responseResponse = await axios.post(
                    `${constants.QORANI}investigationResp/add`,
                    {
                      investigationQstId: question.id,
                      response: response.response,
                      responseEn: response.responseEn,
                    }
                  );
                  response.id = responseResponse.data.id;
                }
              }
            }
          } else {
            // Création d'une nouvelle enquête
            const investigationResponse = await axios.post(
              constants.QORANI + "investigation/add",
              {
                title: this.formData.title,
                titleEn: this.formData.titleEn,
              }
            );
            this.formData.id = investigationResponse.data.id;

            // Création des questions et réponses
            for (const question of this.formData.investigationQstRespList) {
              const questionResponse = await axios.post(
                constants.QORANI + "investigationQst/add",
                {
                  investigationId: investigationResponse.data.id,
                  question: question.question,
                  questionEn: question.questionEn,
                }
              );
              question.id = questionResponse.data.id;

              for (const response of question.investigationRespRespList) {
                const responseResponse = await axios.post(
                  constants.QORANI + "investigationResp/add",
                  {
                    investigationQstId: questionResponse.data.id,
                    response: response.response,
                    responseEn: response.responseEn,
                  }
                );
                response.id = responseResponse.data.id;
              }
            }
          }

          this.$emit("saved");
          this.$refs.form.reset();
        } catch (error) {
          console.error("Erreur lors de la sauvegarde:", error);
        }
      }
    },
  },
};
</script>
